import Layout from '@/components/Layout/Layout';
import Card from '@/components/UI/Card';
import FormField from '@/components/UI/FormField';
import { errorTypes } from '@/utility/validation';
import { useForm } from 'react-hook-form';
import ErrorMessage from '../../../components/common/ErrorMessage';
import { getDeviceId, showToastNotification } from '@/utility/helper';
import { API_ENDPOINT, API_URL_USER_SERVICE } from '@/api/constant';
import { callApi } from '@/api/callApi';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesLink } from '@/utility/RouteLinks';
interface AddDriverProp {
  fullName: string;
  email: string;
  phone: string;
  password: string;
  vehicleNumber: string;
  vehicleMakeModel: string;
}
const AddDriver = () => {
  const navigate = useNavigate();
  const [roleId, setRoleId] = useState<string>('');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AddDriverProp>({
    defaultValues: {
      fullName: '',
      email: '',
      password: '',
      vehicleNumber: '',
      vehicleMakeModel: '',
    },
  });

  const fetchRoles = async () => {
    try {
      const PATH = `${API_URL_USER_SERVICE}${API_ENDPOINT.roles}/search?query=driver`;
      const res = await callApi(PATH, { method: 'GET' });
      setRoleId(res[0].id);
    } catch (error) {
      console.log('error in role fetch', error);
    }
  };

  const onSubmit = async (data: AddDriverProp) => {
    try {
      const PATH = `${API_URL_USER_SERVICE}${API_ENDPOINT.auth}/create-driver`;
      const payload = {
        ...data,
        roleId,
        deviceId: getDeviceId(),
        deviceToken: getDeviceId(),
        profilePhoto: 'https://example.com/image.png',
        vehicleDocumentImage: 'https://example.com/image.png',
        drivingLicenceImage: 'https://example.com/image.png',
      };
      await callApi(PATH, { method: 'POST', data: payload });
      navigate(RoutesLink.order);
    } catch (error) {
      const err = error as { message: string };
      showToastNotification('danger', err.message);
      console.log('error in add driver', error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <Layout>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
        <Card>
          <h2 className="text-lg font-semibold mb-4">Driver Info</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <FormField
                label="Name"
                placeholder="Enter full name"
                {...register('fullName', { ...errorTypes.required('Name') })}
              />
              <ErrorMessage message={errors.fullName?.message} />
            </div>
            <div>
              <FormField
                label="Email"
                placeholder="Enter email address"
                {...register('email', {
                  ...errorTypes.required('email'),
                  ...errorTypes.email,
                })}
              />
              <ErrorMessage message={errors.email?.message} />
            </div>
            <div>
              <FormField
                label="Phone No."
                placeholder="Enter phone number"
                {...register('phone', {
                  ...errorTypes.required('phone no.'),
                })}
              />
              <ErrorMessage message={errors.phone?.message} />
            </div>
            <div>
              <FormField
                label="Password"
                placeholder="Enter a secure password"
                {...register('password', {
                  ...errorTypes.required('password'),
                  ...errorTypes.password,
                })}
              />
              <ErrorMessage message={errors.password?.message} />
            </div>
          </div>
        </Card>
        <Card>
          <h2 className="text-lg font-semibold mb-4">Vehicle Info</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <FormField
                label="vehicleNumber"
                placeholder="Enter vehicle number"
                {...register('vehicleNumber', {
                  ...errorTypes.required('Vehicle No.'),
                })}
              />
              <ErrorMessage message={errors.vehicleNumber?.message} />
            </div>
            <div>
              <FormField
                label="Model Name"
                placeholder="Enter vehicle model name"
                {...register('vehicleMakeModel', {
                  ...errorTypes.required('Vechicle Model'),
                })}
              />
              <ErrorMessage message={errors.vehicleMakeModel?.message} />
            </div>
          </div>
        </Card>
        {/* Action Buttons */}
        <div className="flex justify-end gap-3">
          <button className="btn-secondary">Cancel</button>
          <button className="btn-primary">Save</button>
        </div>
      </form>
    </Layout>
  );
};

export default AddDriver;
